import 'flatpickr/dist/flatpickr.min.css';
import flatpickr from 'flatpickr';
import { German } from 'flatpickr/dist/l10n/de.js';

((Drupal, once) => {
  Drupal.behaviors.initCustomDatepicker = {
    attach: (context) => {
      const dateInputs = once(
        'custom-datepicker',
        '.js-form-type-date input[type="date"]',
        context,
      );

      const locale =
        document.documentElement.lang === 'de' ? German : 'default';

      for (const input of dateInputs) {
        flatpickr(input, {
          allowInput: true,
          dateFormat: 'Y-m-d', // Drupal default
          altInput: true,
          altFormat: 'd.m.Y', // German
          locale: locale,
          disableMobile: true, // Prevent native mobile pickers from showing up, keep custom UI everywhere
        });
      }
    },
  };
})(Drupal, once);
